import React from "react";

import { MenuRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useMainState from "../../config/context/mainStateContext";
import useModal from "../../config/context/modalContext";
import { SpottService } from "../../config/services/SpottService";
import { GreyPallet } from "../../config/styles";

import MainText from "../../components/MainText";
import PageHeader from "../../components/PageHeader";

import { SpottPostType } from "../../types/database";

export default function AccountPostsPage() {
  const { currentUserState, currentUserInfo } = useAuth();
  const navigate = useNavigate();

  const { pushAlert } = useModal();
  const { setShowSideMenuDrawer } = useMainState();

  const SpottList = SpottService.ListFromUser();

  React.useEffect(() => {
    if (currentUserState) {
      SpottList.runRequest(currentUserState?.uid);
    }
  }, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Meus Posts"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        {SpottList.isLoading ? (
          <Box>
            <Box mt={2}>
              <Skeleton
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={90}
                sx={{ borderRadius: "15px", margin: "0px 4px" }}
              />
            </Box>
            <Box mt={2}>
              <Skeleton
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={120}
                sx={{ borderRadius: "15px", margin: "0px 4px" }}
              />
            </Box>
          </Box>
        ) : SpottList.items?.length ? (
          SpottList.items.map((item: SpottPostType) => (
            <Box
              key={item.id}
              mt={2}
              p={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
                border: `3px solid ${GreyPallet.Regular}`,
                borderRadius: "15px",
                minHeight: 60,
              }}
            >
              <MainText size="small" color="regular">
                {DateTime.fromMillis(item.createdAtTimestamp).toFormat("dd/LL/y HH:mm")}
              </MainText>
              <MainText>{item.text}</MainText>
              <MainText size="small" color="regular">
                {item.status === "approved"
                  ? "Post Aprovado"
                  : item.status === "rejected"
                  ? "Post Rejeitado"
                  : "Aguardando aprovação"}
              </MainText>
            </Box>
          ))
        ) : (
          <MainText size="caption" color="regular">
            Você ainda não foi atrás de nenhum contatinho...
          </MainText>
        )}
      </Box>
    </Box>
  );
}
